/**
 * «A sessão terminou»: o `/vs` respondeu que a pessoa já não está autenticada. Tapa o painel
 * (não fecha) e só deixa actualizar a página. Usado no painel do Logigate e na app do POS.
 */
import * as React from "react";
import { useId, useState } from "react";
import { RotateCw, ShieldAlert } from "lucide-react";
import { Botao } from "@/Logigate/ui/base";
import { CamadaExclusiva } from "@/Logigate/components/CamadaExclusiva";

interface Props {
    open: boolean;
}

export default function ModalAutenticacao(props: Props) {
    const idTitulo = useId();
    const [aActualizar, setAActualizar] = useState(false);

    return (
        <CamadaExclusiva aberta={props.open} idTitulo={idTitulo}>
            <div className="w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-2xl ring-1 ring-zinc-950/5 animate-in fade-in-0 zoom-in-95 sm:p-8 dark:bg-zinc-900 dark:ring-white/10">
                <span className="mx-auto flex size-14 items-center justify-center rounded-2xl bg-red-50 text-red-600 dark:bg-red-500/10 dark:text-red-400">
                    <ShieldAlert className="size-7" aria-hidden />
                </span>
                <h2 id={idTitulo} className="mt-4 text-lg font-semibold text-zinc-900 dark:text-zinc-50">
                    Erro de autenticação
                </h2>
                <p className="mt-1.5 text-sm leading-relaxed text-zinc-500 dark:text-zinc-400">
                    Parece que já não estás autenticado. Actualiza a página para continuar.
                </p>
                <Botao
                    larguraTotal
                    tamanho="lg"
                    className="mt-6"
                    icone={<RotateCw className="size-4" />}
                    aCarregar={aActualizar}
                    onClick={() => {
                        setAActualizar(true);
                        window.location.reload();
                    }}
                >
                    Actualizar agora
                </Botao>
            </div>
        </CamadaExclusiva>
    );
}
